<template>
  <div class="lang">
    <a
      class="lang__item"
      :class="{ active: language === 'uz' }"
      @click="selected('uz')"
    >
      <img class="img" :src="linkImg+'/img/041-uzbekistan.png'" alt="" />
    </a>
    <a
      class="lang__item"
      :class="{ active: language === 'ru' }"
      @click="selected('ru' )"
    >
      <img class="img" :src="linkImg+'/img/044-russia.png'" alt="" />
    </a>
    <a
      class="lang__item"
      :class="{ active: language === 'en' }"
      @click="selected('en')"
    >
      <img class="img" :src="linkImg+'/img/186-united-states.png'" alt="" />
    </a>
  </div>
</template>

<script>

export default {
  data() {
    return {
      infos: [],
      language: this.$route.params.lang,
      // uz: 'uz',
      linkImg: ''
    }
  },
  beforeMount() {
    this.linkImg = window.MY_CONFIG_EASYQ.linkImg;
  },
  methods: {
    selected(id) {
      // localStorage.local = id;
      this.$i18n.locale = id;
      this.language = id;
      this.$route.params.lang = id;
      // this.$emit('callParentFunction');

      const url = window.location.href;
      const re = url.split('/');
      console.log(re);
      window.location = re[0] + '//' + re[2] + '/' + re[3] + '/' + id + '/';
      // console.log(window.location);
    },
  },
}
</script>